<ul class="mobile-overflow uk-accordion" uk-accordion>
  <li class="uk-open">
    <p class="uk-accordion-title uk-heading-divider mt-10" href="#">{{name}}</p>
    <div class="uk-accordion-content">
      <div class="uk-grid">
        <div class="uk-width-1-3">
          <label *ngIf="interestedEntity.private_person">Imię i nazwisko</label>
          <label *ngIf="!interestedEntity.private_person">Nazwa firmy</label>
          <input [(ngModel)]="interestedEntity.name"
                 class="uk-input"
                 [disabled]="disabled"
                 (change)="onChangedEvent()"
                 id="interestedEntityName"
          >

          <app-validation-error-badge
            [validationErrors]="validationErrors"
            [activatorKey]="type + '.name'"
          ></app-validation-error-badge>
        </div>
        <div class="uk-width-1-3">
          <label>Firma</label>
          <select class="uk-select"
                  [(ngModel)]="interestedEntity.private_person"
                  [disabled]="disabled"
                  (change)="privatePersonChanged()"
                  id="privatePersonSelect"
          >
            <option value="false">Tak</option>
            <option value="true">Nie</option>
          </select>
          <app-validation-error-badge
            [validationErrors]="validationErrors"
            [activatorKey]="type + '.private_person'"
          ></app-validation-error-badge>
        </div>
        <div class="uk-width-1-3" *ngIf="interestedEntity.private_person">
        </div>
        <div class="uk-width-1-3" *ngIf="!interestedEntity.private_person">
          <label>Osoba kontaktowa</label>
          <input [(ngModel)]="interestedEntity.contact_name"
                 [disabled]="disabled"
                 class="uk-input"
                 (change)="onChangedEvent()"
                 id="contactPersonName"
          >
          <app-validation-error-badge
            [validationErrors]="validationErrors"
            [activatorKey]="type + '.contact_name'"
          ></app-validation-error-badge>
        </div>

        <div class="uk-width-1-3">
          <div class="uk-grid">
            <div class="uk-width-1-3">
              <label>Prefix</label>
              <input [(ngModel)]="interestedEntity.phone.prefix"
                     [disabled]="disabled"
                     class="uk-input"
                     (change)="onChangedEvent()"
                     id="phoneNumberPrefix"
              >
              <app-validation-error-badge
                [validationErrors]="validationErrors"
                [activatorKey]="type + '.phone.prefix'"
              ></app-validation-error-badge>
            </div>
            <div class="uk-width-2-3">
              <label>Numer</label>
              <input [(ngModel)]="interestedEntity.phone.number"
                     [disabled]="disabled"
                     class="uk-input"
                     (change)="onChangedEvent()"
                     id="phoneNumber"
              >
              <app-validation-error-badge
                [validationErrors]="validationErrors"
                [activatorKey]="type + '.phone.number'"
              ></app-validation-error-badge>
            </div>
          </div>
        </div>

        <div class="uk-width-1-3">
          <label>Adres email</label>
          <input [(ngModel)]="interestedEntity.email"
                 [disabled]="disabled"
                 class="uk-input"
                 (change)="onChangedEvent()"
                 id="email"
          >
          <app-validation-error-badge
            [validationErrors]="validationErrors"
            [activatorKey]="type + '.email'"
          ></app-validation-error-badge>
        </div>
      </div>
      <p class="uk-heading-divider">Adres</p>
      <div class="uk-grid">
        <div class="uk-width-1-3">
          <label>Kraj</label>
          <input [(ngModel)]="interestedEntity.country.name"
                 disabled
                 class="uk-input"
          >
        </div>
        <div class="uk-width-1-3" *ngIf="isSender || (false === isSender && false === isLockerService)">
          <label>Miejscowość</label>
          <search-locality-select
            [countryId]="interestedEntity.country.id"
            [locality]="interestedEntity.address.locality"
            [disabled]="disabled"
            (onLocalityChangedEvent)="localityChangedEventHandler($event)"
          >
          </search-locality-select>
          <app-validation-error-badge
            [validationErrors]="validationErrors"
            [activatorKey]="type + '.address.locality_id'"
          ></app-validation-error-badge>
        </div>
        <div class="uk-width-1-3"  *ngIf="isSender || (false === isSender && false === isLockerService)">
          <label>Kod pocztowy</label>
          <input [(ngModel)]="interestedEntity.address.postal_code"
                 [disabled]="disabled"
                 class="uk-input"
          >
        </div>

        <div class="uk-width-2-3" *ngIf="isSender || (false === isSender && false === isLockerService)">
          <label>Adres</label>
          <search-locality-street-select
            [details]="interestedEntity.address.details"
            [localityId]="interestedEntity.address.locality.id"
            [disabled]="disabled || null === interestedEntity.address.locality.id"
            (onAddressDetailsChangedEvent)="addressDetailsChangedEventHandler($event)"
          >
          </search-locality-street-select>
          <app-validation-error-badge
            [validationErrors]="validationErrors"
            [activatorKey]="type + '.address.details'"
          ></app-validation-error-badge>
        </div>

        <div class="uk-width-2-3" *ngIf="isLockerService">
          <label>Automat paczkowy</label>
          <search-locker-select
            [locker]="interestedEntity.locker"
            [countryId]="interestedEntity.country.id"
            [disabled]="disabled"
            (onLockerChangedEvent)="lockerChangedEventHandler($event)"
          >
          </search-locker-select>
          <app-validation-error-badge
            [validationErrors]="validationErrors"
            [activatorKey]="type + '.locker_id'"
          ></app-validation-error-badge>
        </div>
      </div>
    </div>
  </li>
</ul>



